s<template>
  <v-btn
    class="font-weight-medium"
    :color="color"
    depressed
    large
    dark
    @click="exportCsv"
    :loading="loading"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonExportCSV',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: 'primary',
    },
    label: {
      type: String,
      default: 'EXPORTAR CSV',
    },
    filename: {
      type: String,
      default: 'export.csv',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    exportCsv() {
      const rows = [];
      this.items.forEach((item) => {
        const { status, movements = [] } = item;
        movements.forEach((m) => {
          rows.push({ status, ...m });
        });
      });

      if (!rows.length) {
        this.$emit('no-data');
        return;
      }

      const headersSet = new Set();
      rows.forEach((r) => Object.keys(r).forEach((k) => headersSet.add(k)));
      const headers = Array.from(headersSet);

      const escape = (v) => {
        if (v === null || v === undefined) return '';
        const s = String(v);
        if (/[",\n\r]/.test(s)) {
          return `"${s.replace(/"/g, '""')}"`;
        }
        return s;
      };

      const csv = [headers.join(',')]
        .concat(rows.map((r) => headers.map((h) => escape(r[h] ?? '')).join(',')))
        .join('\n');

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', this.filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.$emit('exported');
    },
  },
};
</script>

<style scoped>
.v-btn {
  min-width: 160px;
}
</style>
